import Error from '../../../model/Error.js';
import axios from 'axios';

export default class DogUsabilityPassRepository {

    static createByDogId(dogId, dogUsabilityPass) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/dogs/${dogId}/usability-passes`, dogUsabilityPass)
                .then(response => resolve(response.headers['x-identifier']))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
